
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Privacy from "../pages/privacy/page";
import Terms from "../pages/terms/page";
import Disclaimer from "../pages/disclaimer/page";
import PersonalInfo from "../pages/personal-info/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/disclaimer",
    element: <Disclaimer />,
  },
  {
    path: "/personal-info",
    element: <PersonalInfo />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
